import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@razz-team/ui-web';
import { mapNetworkToFullName } from '@razz-team/utils';
import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';
import { ApiAccountAddress } from '../../openapi';

interface QRDialogProps {
  open: boolean;
  onClose: () => void;
  address: ApiAccountAddress;
}

export function QRDialog({ open, onClose, address }: QRDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        {t('{{ network }} address', { network: mapNetworkToFullName(address.type) })}
      </DialogTitle>
      <DialogContent>
        <QRCode size={256} value={address.value || ''} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('Close')}</Button>
      </DialogActions>
    </Dialog>
  );
}
